(function () {
  'use strict';

  var iconMarkup = {
    success: '<svg class="merlons-cart-icon merlons-cart-icon--success" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8"/><path d="M8 12.5L10.6 15L16.5 9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    trash: '<svg class="merlons-cart-icon merlons-cart-icon--trash" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M4 7H20M9 7V4H15V7M7 7L8 20H16L17 7M10 11V16M14 11V16" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    truck: '<svg class="merlons-cart-icon merlons-cart-icon--truck" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M3 6H14V17H3V6ZM14 10H18L21 13V17H14V10ZM6.5 20C7.88071 20 9 18.8807 9 17.5C9 16.1193 7.88071 15 6.5 15C5.11929 15 4 16.1193 4 17.5C4 18.8807 5.11929 20 6.5 20ZM17.5 20C18.8807 20 20 18.8807 20 17.5C20 16.1193 18.8807 15 17.5 15C16.1193 15 15 16.1193 15 17.5C15 18.8807 16.1193 20 17.5 20Z" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    close: '<svg class="merlons-cart-icon merlons-cart-icon--close" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>'
  };

  function createIcon(kind) {
    var template = document.createElement('template');
    template.innerHTML = iconMarkup[kind];
    return template.content.firstElementChild;
  }

  function replaceMatches(root, selector, kind) {
    var matches = [];
    if (root.nodeType === 1 && root.matches(selector)) matches.push(root);
    if (root.querySelectorAll) matches = matches.concat(Array.prototype.slice.call(root.querySelectorAll(selector)));
    matches.forEach(function (icon) {
      if (!icon.classList.contains('merlons-cart-icon')) icon.replaceWith(createIcon(kind));
    });
  }

  function normalizeMiniCartRemoveControls(root) {
    var controls = [];
    if (root.nodeType === 1 && root.matches('.remove-from-cart')) controls.push(root);
    if (root.querySelectorAll) controls = controls.concat(Array.prototype.slice.call(root.querySelectorAll('.remove-from-cart')));
    controls.forEach(function (control) {
      var label = window.theme && window.theme.strings && window.theme.strings.remove
        ? window.theme.strings.remove
        : control.getAttribute('aria-label') || control.getAttribute('title') || '';
      if (control.tagName !== 'BUTTON') {
        var button = document.createElement('button');
        Array.prototype.forEach.call(control.attributes, function (attribute) {
          if (attribute.name !== 'href' && attribute.name !== 'rel' && attribute.name !== 'title' && attribute.name !== 'aria-label') {
            button.setAttribute(attribute.name, attribute.value);
          }
        });
        button.type = 'button';
        while (control.firstChild) button.appendChild(control.firstChild);
        control.replaceWith(button);
        control = button;
      } else {
        control.type = 'button';
      }
      if (label) {
        control.setAttribute('title', label);
        control.setAttribute('aria-label', label);
      }
    });
  }

  function normalizeQuantityControls(root) {
    var selector = '.cart__mini-qty, .cart__popup-qty, .cart__qty .js-qty__adjust';
    var controls = [];
    if (root.nodeType === 1 && root.matches(selector)) controls.push(root);
    if (root.querySelectorAll) controls = controls.concat(Array.prototype.slice.call(root.querySelectorAll(selector)));
    controls.forEach(function (control) {
      var isIncrease = control.classList.contains('plus') || control.classList.contains('cart__mini-qty--plus') || control.classList.contains('cart__popup-qty--plus');
      var label = window.theme && window.theme.strings
        ? window.theme.strings[isIncrease ? 'increase_quantity' : 'reduce_quantity']
        : '';
      if (control.tagName === 'A') {
        var button = document.createElement('button');
        Array.prototype.forEach.call(control.attributes, function (attribute) {
          if (attribute.name !== 'href' && attribute.name !== 'role' && attribute.name !== 'tabindex') {
            button.setAttribute(attribute.name, attribute.value);
          }
        });
        button.type = 'button';
        while (control.firstChild) button.appendChild(control.firstChild);
        control.replaceWith(button);
        control = button;
      } else if (control.tagName === 'BUTTON') {
        control.type = 'button';
      }
      if (label) {
        control.setAttribute('title', label);
        control.setAttribute('aria-label', label);
      }
    });
  }

  function normalizeHeaderCartControls(root) {
    var controls = [];
    if (root.nodeType === 1 && root.matches('.header-cart')) controls.push(root);
    if (root.querySelectorAll) controls = controls.concat(Array.prototype.slice.call(root.querySelectorAll('.header-cart')));
    controls.forEach(function (control) {
      var label = headerCartBaseLabel(control);
      var isNativeButton = control.tagName === 'BUTTON' || control.tagName === 'INPUT';
      var isNativeLink = control.tagName === 'A' && control.hasAttribute('href');
      if (!isNativeButton && !isNativeLink) {
        control.setAttribute('role', 'button');
        control.setAttribute('tabindex', '0');
      }
      if (document.getElementById('desktop_cart')) {
        control.setAttribute('aria-controls', 'desktop_cart');
      }
      if (label) {
        control.setAttribute('title', label);
      }
    });
    // Only new header/count markup needs a document-wide count-label refresh.
    // Unrelated lazy images and app DOM insertions must not repeat that work.
    if (controls.length || (root.nodeType === 1 && root.matches('.CartCount, #CartCountCavas'))
      || (root.querySelector && root.querySelector('.CartCount, #CartCountCavas'))) {
      updateHeaderCartAccessibleNames();
    }
    syncHeaderCartExpandedState();
  }

  function headerCartBaseLabel(control) {
    if (!control) return '';
    var storedLabel = control.getAttribute('data-merlons-cart-base-label');
    if (storedLabel) return storedLabel;
    var label = control.getAttribute('aria-label')
      || (window.theme && window.theme.strings && window.theme.strings.cart_title)
      || (control.querySelector('[title]') && control.querySelector('[title]').getAttribute('title'))
      || '';
    label = String(label).replace(/\s+\(\d+\)\s*$/, '').trim();
    if (label) control.setAttribute('data-merlons-cart-base-label', label);
    return label;
  }

  function updateHeaderCartAccessibleNames(itemCount) {
    var fallbackCount = itemCount == null ? null : String(itemCount);
    Array.prototype.forEach.call(document.querySelectorAll('.header-cart'), function (control) {
      var baseLabel = headerCartBaseLabel(control);
      if (!baseLabel) return;
      var count = control.querySelector('.CartCount');
      var visibleCount = count && count.textContent.trim();
      if (!visibleCount) visibleCount = fallbackCount;
      if (!visibleCount) {
        var globalCount = document.querySelector('.CartCount, #CartCountCavas');
        visibleCount = globalCount && globalCount.textContent.trim();
      }
      var label = visibleCount ? baseLabel + ' (' + visibleCount + ')' : baseLabel;
      if (control.getAttribute('aria-label') !== label) control.setAttribute('aria-label', label);
    });
  }

  function syncHeaderCartExpandedState() {
    var drawer = document.getElementById('desktop_cart');
    var expanded = !!(drawer && drawer.classList.contains('active'));
    Array.prototype.forEach.call(document.querySelectorAll('.header-cart'), function (control) {
      control.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  function localizeCartNavigation(root) {
    if (!root || (root.nodeType !== 1 && root.nodeType !== 9 && root.nodeType !== 11)) return;

    var cartUrl = localizedCartUrl('cart');
    var candidates = [];
    if (root.nodeType === 1 && root.matches('a[href="/cart"], form[action="/cart"]')) candidates.push(root);
    if (root.querySelectorAll) {
      candidates = candidates.concat(Array.prototype.slice.call(root.querySelectorAll('a[href="/cart"], form[action="/cart"]')));
    }

    candidates.forEach(function (element) {
      if (!element.closest('#cart-info, .ajaxcart')) return;
      if (element.tagName === 'FORM') {
        element.setAttribute('action', cartUrl);
      } else {
        element.setAttribute('href', cartUrl);
      }
    });
  }

  function repairCartIcons(root) {
    if (!root || (root.nodeType !== 1 && root.nodeType !== 9 && root.nodeType !== 11)) return;

    normalizeMiniCartRemoveControls(root);
    normalizeQuantityControls(root);
    normalizeHeaderCartControls(root);
    localizeCartNavigation(root);

    var messages = [];
    if (root.nodeType === 1 && root.matches('.cart-message')) messages.push(root);
    if (root.querySelectorAll) messages = messages.concat(Array.prototype.slice.call(root.querySelectorAll('.cart-message')));
    messages.forEach(function (message) {
      var icon = message.querySelector(':scope > i');
      if (icon) icon.replaceWith(createIcon(message.classList.contains('removed') ? 'trash' : 'success'));
    });

    replaceMatches(root, '.cart__popup-remove i.rbb-icon-delete-outline-2, .remove-from-cart i.rbb-icon-delete-outline-2, .cart__remove i.rbb-icon-delete-outline-2', 'trash');
    replaceMatches(root, '.threshold_bar i.rbb-icon-delivery-11, .threshold_spend i.rbb-icon-delivery-11', 'truck');
    replaceMatches(root, '.cart_extend--label i.zmdi-close, .extend--label__item i.zmdi-close', 'close');
  }

  var discountRequestInFlight = false;
  var discountRefreshQueued = false;
  var discountRefreshTimer = 0;
  var discountContentVersion = 0;
  var quantityRequestInFlight = false;
  var quantityProcessTimer = 0;
  var quantitySyncTimer = 0;
  var quantityActivityVersion = 0;
  var quantityPending = Object.create(null);
  var quantitySyncController = null;
  var quantityRecoveryNeeded = false;
  var pricingRefreshGuard = window.MerlonsCartPricing && typeof window.MerlonsCartPricing.createRevisionGuard === 'function'
    ? window.MerlonsCartPricing.createRevisionGuard()
    : null;
  var lastKnownCart = null;
  var pendingQuantityFocus = null;
  var lastHeaderCartTrigger = null;
  var quantityProcessDelay = 45;
  var quantityFragmentDelay = 30;

  function discountProgressEnabled() {
    return !window.theme || window.theme.show_cart_discount_progress !== false;
  }

  function localizedCartViewUrl() {
    var root = window.MerlonsLocalizedRoutes && window.MerlonsLocalizedRoutes.root
      ? window.MerlonsLocalizedRoutes.root()
      : window.theme && window.theme.localizedRootUrl
        ? window.theme.localizedRootUrl
        : window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';
    return root.replace(/\/?$/, '/') + 'cart?view=ship';
  }

  function localizedCartPricingUrl() {
    var root = window.MerlonsLocalizedRoutes && window.MerlonsLocalizedRoutes.root
      ? window.MerlonsLocalizedRoutes.root()
      : window.theme && window.theme.localizedRootUrl
        ? window.theme.localizedRootUrl
        : window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';
    return root.replace(/\/?$/, '/') + 'cart?view=pricing';
  }

  function refreshCartPricing(cart) {
    if (!cart || !window.MerlonsCartPricing || typeof window.MerlonsCartPricing.fetchSnapshot !== 'function') return;
    if (typeof window.MerlonsCartPricing.seedFromDom === 'function') {
      window.MerlonsCartPricing.seedFromDom(cart, document);
    }
    var pricingRevision = pricingRefreshGuard ? pricingRefreshGuard.next() : 0;
    window.MerlonsCartPricing.fetchSnapshot(cart, localizedCartPricingUrl()).then(function (compareAtByKey) {
      if (pricingRefreshGuard && !pricingRefreshGuard.isCurrent(pricingRevision)) return;
      if (window.MerlonsCartPricing && typeof window.MerlonsCartPricing.updateDom === 'function') {
        window.MerlonsCartPricing.updateDom(document, cart, compareAtByKey, function (value) { return formatCartMoney(value, cart.currency); });
      }
    });
  }

  function localizedCartUrl(suffix) {
    var root = window.MerlonsLocalizedRoutes && window.MerlonsLocalizedRoutes.root
      ? window.MerlonsLocalizedRoutes.root()
      : window.theme && window.theme.localizedRootUrl
        ? window.theme.localizedRootUrl
        : window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';
    return root.replace(/\/?$/, '/') + suffix.replace(/^\//, '');
  }

  function ensureMiniCartDiscountTarget() {
    var footer = document.querySelector('#cart-info .ajaxcart__footer');
    if (!footer) return null;

    var target = footer.querySelector('#threshold_bar_popup_minicart');
    if (!target) {
      target = document.createElement('div');
      target.id = 'threshold_bar_popup_minicart';
      target.className = 'cart_threshold merlons-cart-discount-progress';
      var buttons = footer.querySelector('.btn_submit');
      footer.insertBefore(target, buttons || null);
    }
    return target;
  }

  function refreshMiniCartDiscountProgress(force) {
    if (!discountProgressEnabled()) return;
    if (discountRequestInFlight) {
      discountRefreshQueued = true;
      return;
    }
    var target = ensureMiniCartDiscountTarget();
    if (!target || (!force && target.dataset.merlonsDiscountLoaded === 'true')) return;

    var requestVersion = discountContentVersion;
    discountRequestInFlight = true;
    target.setAttribute('aria-busy', 'true');
    window.fetch(localizedCartViewUrl(), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart discount progress request failed');
        return response.text();
      })
      .then(function (html) {
        if (requestVersion !== discountContentVersion || ensureMiniCartDiscountTarget() !== target) return;
        replaceCartPriceSummariesFromFragment(html);
        target.dataset.merlonsDiscountLoaded = 'true';
        target.innerHTML = html;
        target.hidden = html.trim() === '';
        repairCartIcons(target);
      })
      .catch(function () {
        target.hidden = true;
      })
      .finally(function () {
        target.removeAttribute('aria-busy');
        discountRequestInFlight = false;
        if (discountRefreshQueued) {
          var queuedForce = discountRefreshQueued;
          discountRefreshQueued = false;
          scheduleMiniCartDiscountRefresh(queuedForce, 40);
        }
      });
  }

  function scheduleMiniCartDiscountRefresh(force, delay) {
    if (!discountProgressEnabled()) return;
    window.clearTimeout(discountRefreshTimer);
    discountRefreshTimer = window.setTimeout(function () {
      refreshMiniCartDiscountProgress(force);
    }, typeof delay === 'number' ? delay : 80);
  }

  function mutationTouchesMiniCart(mutation) {
    if (!mutation || mutation.type !== 'childList') return false;
    if (mutation.target.nodeType === 1 && mutation.target.closest('.merlons-cart-discount-progress')) return false;
    if (mutation.target.nodeType === 1 && mutation.target.closest('#cart-info')) return true;
    return Array.prototype.some.call(mutation.addedNodes, function (node) {
      return node.nodeType === 1 && (node.id === 'cart-info' || node.matches('.ajaxcart, .ajaxcart__footer') || node.querySelector('.ajaxcart__footer'));
    });
  }

  function cartQuantityInputSelector() {
    return '.cart__mini-qty--input, .cart__qty-input, .cart__popup-qty--input';
  }

  function findQuantityInput(control) {
    if (!control) return null;
    if (control.matches(cartQuantityInputSelector())) return control;
    var wrapper = control.closest('.cart__mini--qty, .cart__qty, .cart__popup-quantity');
    return wrapper ? wrapper.querySelector(cartQuantityInputSelector()) : null;
  }

  function quantityIdentity(input) {
    var key = input.getAttribute('data-key');
    if (!key && input.id && input.id.indexOf('updates_') === 0) key = input.id.slice(8);
    return {
      key: key || '',
      line: parseInt(input.getAttribute('data-line'), 10) || 0
    };
  }

  function cartFocusSurface(control) {
    if (!control || !control.closest) return null;
    if (control.closest('#cart-info')) {
      return { rootSelector: '#cart-info', rowSelector: '.ajaxcart__product' };
    }
    if (control.closest('.cart__popup_content')) {
      return { rootSelector: '.cart__popup_content', rowSelector: '.cart__popup-item' };
    }
    if (control.closest('[data-section-type="cart-template"]')) {
      return { rootSelector: '[data-section-type="cart-template"]', rowSelector: '.cart_item' };
    }
    return null;
  }

  function cartFocusKind(control) {
    if (!control || !control.matches) return 'input';
    if (control.matches('.remove-from-cart, .cart__remove, .cart__popup-remove a')) return 'remove';
    if (control.matches('.plus, .cart__mini-qty--plus, .cart__popup-qty--plus')) return 'plus';
    if (control.matches('.minus, .cart__mini-qty--minus, .cart__popup-qty--minus')) return 'minus';
    return 'input';
  }

  function captureQuantityFocus(input, control, removal) {
    var source = control || input;
    var surface = cartFocusSurface(source);
    var row = source && source.closest && source.closest('.cart_item, .ajaxcart__product');
    if (!surface || !row) return null;
    var root = document.querySelector(surface.rootSelector);
    var rows = root ? Array.prototype.slice.call(root.querySelectorAll(surface.rowSelector)) : [];
    return {
      identity: quantityIdentity(input),
      kind: cartFocusKind(source),
      removal: !!removal,
      rootSelector: surface.rootSelector,
      rowSelector: surface.rowSelector,
      rowIndex: Math.max(0, rows.indexOf(row)),
      originalControl: source,
      version: quantityActivityVersion
    };
  }

  function rowMatchesQuantityIdentity(row, identity) {
    if (!row || !identity) return false;
    var inputs = row.querySelectorAll(cartQuantityInputSelector());
    for (var index = 0; index < inputs.length; index += 1) {
      var candidate = quantityIdentity(inputs[index]);
      if (identity.key && candidate.key === identity.key) return true;
      if (!identity.key && identity.line && candidate.line === identity.line) return true;
    }
    return false;
  }

  function equivalentCartControl(row, kind) {
    if (!row) return null;
    if (kind === 'plus') return row.querySelector('.cart__mini-qty--plus, .cart__popup-qty--plus, .cart__qty .plus');
    if (kind === 'minus') return row.querySelector('.cart__mini-qty--minus, .cart__popup-qty--minus, .cart__qty .minus');
    if (kind === 'remove') return row.querySelector('.remove-from-cart, .cart__remove, .cart__popup-remove a');
    return row.querySelector(cartQuantityInputSelector());
  }

  function scheduleQuantityFocusRestore() {
    var focusState = pendingQuantityFocus;
    if (!focusState) return;
    window.requestAnimationFrame(function () {
      if (pendingQuantityFocus !== focusState) return;
      var active = document.activeElement;
      if (active && active !== document.body && active !== document.documentElement && active.isConnected && active !== focusState.originalControl) {
        pendingQuantityFocus = null;
        return;
      }
      if (focusState.originalControl && focusState.originalControl.isConnected && active === focusState.originalControl) {
        pendingQuantityFocus = null;
        return;
      }

      var root = document.querySelector(focusState.rootSelector);
      var rows = root ? Array.prototype.slice.call(root.querySelectorAll(focusState.rowSelector)) : [];
      var row = null;
      for (var index = 0; index < rows.length; index += 1) {
        if (rowMatchesQuantityIdentity(rows[index], focusState.identity)) {
          row = rows[index];
          break;
        }
      }
      if (!row && rows.length) row = rows[Math.min(focusState.rowIndex, rows.length - 1)];

      var target = row && equivalentCartControl(row, rowMatchesQuantityIdentity(row, focusState.identity) ? focusState.kind : 'input');
      if (!target && row) target = row.querySelector(cartQuantityInputSelector() + ', .remove-from-cart, .cart__remove, .cart__popup-remove a');
      if (!target && focusState.rootSelector === '#cart-info') {
        target = document.querySelector('#desktop_cart .close_cart') || document.querySelector('#desktop_cart .cart__canvas--title');
      }
      if (!target && root) {
        target = root.querySelector('.cart__canvas--title, .cart__popup-headingtitle, .cart__heading') || root;
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      }
      if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });
      pendingQuantityFocus = null;
    });
  }

  function clampQuantity(input, value) {
    var min = parseFloat(input.getAttribute('min'));
    var max = parseFloat(input.getAttribute('max'));
    if (!isFinite(min)) min = 1;
    if (!isFinite(max) || max <= 0) max = 99999999;
    value = parseFloat(value);
    if (!isFinite(value)) value = parseFloat(input.value) || min;
    value = Math.round(value);
    return Math.max(min, Math.min(max, value));
  }

  function markQuantityBusy(input, busy) {
    var row = input && input.closest('.cart_item, .ajaxcart__product');
    if (!row) return;
    row.classList.toggle('merlons-cart-quantity-busy', busy);
    if (busy) row.setAttribute('aria-busy', 'true');
    else row.removeAttribute('aria-busy');
  }

  function markRemoveBusy(control, busy) {
    var row = control && control.closest('.cart_item, .ajaxcart__product');
    if (!row) return;
    row.classList.toggle('merlons-cart-remove-busy', busy);
    if (busy) control.setAttribute('aria-disabled', 'true');
    else control.removeAttribute('aria-disabled');
  }

  function formatCartMoney(cents, currency) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var format = window.theme && window.theme.moneyFormat;
      if (typeof window.Shopify.moneyFormatForCurrency === 'function') {
        format = window.Shopify.moneyFormatForCurrency(currency || (window.theme && window.theme.currencyCode));
      }
      return window.Shopify.formatMoney(cents, format);
    }
    var wholeUnits = Math.trunc(Number(cents || 0) / 100);
    var currencyCode = String(currency || (window.theme && window.theme.currencyCode) || 'GEL').toUpperCase();
    var currencySymbols = { GEL: '₾', USD: '$', EUR: '€', GBP: '£', RUB: '₽', TRY: '₺', UAH: '₴', CNY: '¥', JPY: '¥' };
    return wholeUnits.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' ' + (currencySymbols[currencyCode] || currencyCode);
  }

  function replaceCartPriceSummariesFromFragment(html) {
    if (!html) return;
    var parser = document.createElement('template');
    parser.innerHTML = html;
    var summaryTemplate = parser.content.querySelector('template[data-merlons-cart-price-summary-template]');
    var source = summaryTemplate && summaryTemplate.content.querySelector('[data-merlons-cart-price-summary]');
    if (!source) return;

    Array.prototype.forEach.call(document.querySelectorAll('[data-merlons-cart-price-summary]'), function (summary) {
      summary.replaceWith(source.cloneNode(true));
    });
  }

  function pendingQuantityCount() {
    return Object.keys(quantityPending).length;
  }

  function findCartItem(cart, identity) {
    if (!cart || !cart.items) return null;
    if (identity.key) {
      for (var index = 0; index < cart.items.length; index += 1) {
        if (cart.items[index].key === identity.key) return cart.items[index];
      }
    }
    return identity.line > 0 ? cart.items[identity.line - 1] : null;
  }

  function updateCartSummary(cart) {
    if (!cart) return;
    Array.prototype.forEach.call(document.querySelectorAll('.CartCount, #CartCountCavas'), function (count) {
      count.textContent = cart.item_count;
    });
    updateHeaderCartAccessibleNames(cart.item_count);
    Array.prototype.forEach.call(document.querySelectorAll('.cart__subtotal'), function (subtotal) {
      subtotal.innerHTML = formatCartMoney(cart.total_price, cart.currency);
    });
    refreshCartPricing(cart);
    var desktopCart = document.querySelector('#desktop_cart');
    if (desktopCart) desktopCart.classList.toggle('item_count', cart.item_count > 0);
  }

  function updateLocalizedCartLabels(root) {
    if (!root || !root.querySelector) return;
    var source = root.matches && root.matches('[data-merlons-cart-count-label]')
      ? root
      : root.querySelector('[data-merlons-cart-count-label]');
    if (!source) return;

    var countLabel = source.getAttribute('data-merlons-cart-count-label');
    var pageCount = source.getAttribute('data-merlons-cart-page-count');
    var popupCount = source.getAttribute('data-merlons-cart-popup-count');
    var itemCount = parseInt(source.getAttribute('data-merlons-cart-item-count'), 10);
    if (isFinite(itemCount)) {
      Array.prototype.forEach.call(document.querySelectorAll('.CartCount, #CartCountCavas'), function (count) {
        if (count.textContent !== String(itemCount)) count.textContent = itemCount;
      });
      updateHeaderCartAccessibleNames(itemCount);
      var desktopCart = document.querySelector('#desktop_cart');
      if (desktopCart) desktopCart.classList.toggle('item_count', itemCount > 0);
    }
    if (countLabel != null) {
      Array.prototype.forEach.call(document.querySelectorAll('.cart__canvas-count-label'), function (label) {
        if (label.textContent !== countLabel) label.textContent = countLabel;
      });
    }
    if (pageCount != null) {
      Array.prototype.forEach.call(document.querySelectorAll('.merlons-cart-page-count'), function (label) {
        if (label.textContent !== pageCount) label.textContent = pageCount;
      });
    }
    if (popupCount != null) {
      Array.prototype.forEach.call(document.querySelectorAll('.merlons-cart-popup-count'), function (label) {
        if (label.textContent !== popupCount) label.textContent = popupCount;
      });
    }
  }

  function removeMissingCartRows(cart) {
    var rows = [];
    Array.prototype.forEach.call(document.querySelectorAll(cartQuantityInputSelector()), function (input) {
      if (findCartItem(cart, quantityIdentity(input))) return;
      var row = input.closest('.cart_item, .ajaxcart__product');
      if (row && rows.indexOf(row) === -1) rows.push(row);
    });
    rows.forEach(function (row) { row.remove(); });
  }

  function applyFinalCartState(cart) {
    updateCartSummary(cart);
    removeMissingCartRows(cart);
    Array.prototype.forEach.call(document.querySelectorAll(cartQuantityInputSelector()), function (input) {
      var item = findCartItem(cart, quantityIdentity(input));
      if (!item) return;
      input.value = item.quantity;
      input.defaultValue = item.quantity;
      var row = input.closest('.cart_item, .ajaxcart__product');
      var lineTotal = row && row.querySelector('.product-subtotal');
      if (lineTotal && !lineTotal.querySelector('[data-merlons-cart-pricing-line]')) {
        lineTotal.innerHTML = formatCartMoney(item.final_line_price == null ? item.line_price : item.final_line_price, cart.currency);
      }
      markQuantityBusy(input, false);
    });
    Array.prototype.forEach.call(document.querySelectorAll('.merlons-cart-remove-busy'), function (row) {
      row.classList.remove('merlons-cart-remove-busy');
      var control = row.querySelector('.remove-from-cart, .cart__remove, .cart__popup-remove a');
      if (control) control.removeAttribute('aria-disabled');
    });
    document.dispatchEvent(new CustomEvent('merlons:cart:state', { detail: { cart: cart } }));
  }

  function cancelQuantityFragmentSync() {
    window.clearTimeout(quantitySyncTimer);
    if (quantitySyncController) {
      quantitySyncController.abort();
      quantitySyncController = null;
    }
  }

  function replaceCartPageSection(currentSection, html) {
    if (!currentSection || !html) return;
    var template = document.createElement('template');
    template.innerHTML = html;
    var nextSection = template.content.querySelector('[data-section-type="cart-template"]');
    if (!nextSection) throw new Error('Cart page section refresh failed');
    currentSection.innerHTML = nextSection.innerHTML;
    repairCartIcons(currentSection);
  }

  function settleFragment(promise) {
    return promise.then(function (value) {
      return { value: value };
    }, function (error) {
      return { error: error };
    });
  }

  function syncQuantityFragments(cart) {
    var syncVersion = quantityActivityVersion;
    cancelQuantityFragmentSync();
    quantitySyncTimer = window.setTimeout(function () {
      if (quantityRequestInFlight || pendingQuantityCount() || syncVersion !== quantityActivityVersion) return;
      var syncController = typeof window.AbortController === 'function' ? new window.AbortController() : null;
      quantitySyncController = syncController;
      var requestOptions = {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      };
      if (syncController) requestOptions.signal = syncController.signal;

      var miniCart = document.querySelector('#cart-info');
      var progress = document.querySelector('#threshold_bar_popup');
      var cartSection = document.querySelector('[data-section-type="cart-template"]');
      var cartSectionId = cartSection && cartSection.getAttribute('data-section-id');
      if (progress && progress.closest('#cart-info')) progress = null;
      var miniRequest = miniCart
        ? window.fetch(localizedCartUrl('cart?view=json'), requestOptions).then(function (response) {
            if (!response.ok) throw new Error('Mini cart refresh failed');
            return response.text();
          })
        : Promise.resolve(null);
      var progressRequest = progress
        ? window.fetch(localizedCartViewUrl(), requestOptions).then(function (response) {
            if (!response.ok) throw new Error('Cart progress refresh failed');
            return response.text();
          })
        : Promise.resolve(null);
      var cartPageRequest = cartSection && cartSectionId
        ? window.fetch(localizedCartUrl('cart?section_id=' + encodeURIComponent(cartSectionId)), requestOptions).then(function (response) {
            if (!response.ok) throw new Error('Cart page refresh failed');
            return response.text();
          })
        : Promise.resolve(null);

      Promise.all([
        settleFragment(miniRequest),
        settleFragment(progressRequest),
        settleFragment(cartPageRequest)
      ])
        .then(function (responses) {
          if (syncVersion !== quantityActivityVersion || quantityRequestInFlight || pendingQuantityCount()) return;
          if (miniCart && responses[0].value != null) {
            miniCart.innerHTML = responses[0].value;
            repairCartIcons(miniCart);
            updateLocalizedCartLabels(miniCart);
          }
          if (progress && responses[1].value != null) {
            replaceCartPriceSummariesFromFragment(responses[1].value);
            progress.innerHTML = responses[1].value;
            progress.dataset.merlonsDiscountLoaded = 'true';
            progress.hidden = responses[1].value.trim() === '';
            repairCartIcons(progress);
          }
          if (cartSection && responses[2].value != null) {
            try {
              replaceCartPageSection(cartSection, responses[2].value);
            } catch (error) {}
          }
          applyFinalCartState(cart);
          scheduleQuantityFocusRestore();
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          applyFinalCartState(cart);
          scheduleQuantityFocusRestore();
        })
        .finally(function () {
          if (quantitySyncController === syncController) quantitySyncController = null;
        });
    }, quantityFragmentDelay);
  }

  function processNextQuantity() {
    window.clearTimeout(quantityProcessTimer);
    if (quantityRequestInFlight) return;
    var keys = Object.keys(quantityPending);
    if (!keys.length) return;

    var pendingKey = keys[0];
    var job = quantityPending[pendingKey];
    delete quantityPending[pendingKey];
    quantityRequestInFlight = true;

    var identity = job.identity;
    var body = 'quantity=' + encodeURIComponent(job.quantity);
    if (identity.key) body += '&id=' + encodeURIComponent(identity.key);
    else body += '&line=' + encodeURIComponent(identity.line);

    window.fetch(localizedCartUrl('cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: body
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart quantity update failed');
        return response.json();
      })
      .then(function (cart) {
        lastKnownCart = cart;
        updateCartSummary(cart);
        job.cart = cart;
        if (job.removal) removeMissingCartRows(cart);
      })
      .catch(function () {
        job.failed = true;
        quantityRecoveryNeeded = true;
      })
      .finally(function () {
        quantityRequestInFlight = false;
        if (pendingQuantityCount()) {
          processNextQuantity();
          return;
        }
        if (job.cart && !quantityRecoveryNeeded) {
          applyFinalCartState(job.cart);
          syncQuantityFragments(job.cart);
        } else {
          markQuantityBusy(job.input, false);
          markRemoveBusy(job.removeControl, false);
          window.fetch(localizedCartUrl('cart.js'), { credentials: 'same-origin' })
            .then(function (response) {
              if (!response.ok) throw new Error('Cart recovery failed');
              return response.json();
            })
            .then(function (cart) {
              quantityRecoveryNeeded = false;
              lastKnownCart = cart;
              applyFinalCartState(cart);
              syncQuantityFragments(cart);
            })
            .catch(function () {
              quantityRecoveryNeeded = false;
              if (window.location && typeof window.location.reload === 'function') {
                window.location.reload();
              } else if (lastKnownCart) {
                applyFinalCartState(lastKnownCart);
              } else {
                Array.prototype.forEach.call(document.querySelectorAll(cartQuantityInputSelector()), function (input) {
                  input.value = input.defaultValue;
                  markQuantityBusy(input, false);
                });
              }
            });
        }
      });
  }

  function enqueueQuantity(input, quantity, options) {
    options = options || {};
    var identity = quantityIdentity(input);
    if (!identity.key && !identity.line) return;
    quantityActivityVersion += 1;
    if (pricingRefreshGuard) pricingRefreshGuard.next();
    pendingQuantityFocus = captureQuantityFocus(input, options.focusControl || input, options.removal || quantity === 0);
    discountContentVersion += 1;
    cancelQuantityFragmentSync();
    if (!options.removal) input.value = quantity;
    markQuantityBusy(input, true);
    markRemoveBusy(options.removeControl, !!options.removal);
    var pendingKey = identity.key ? 'id:' + identity.key : 'line:' + identity.line;
    quantityPending[pendingKey] = {
      input: input,
      identity: identity,
      quantity: quantity,
      removal: !!options.removal,
      removeControl: options.removeControl || null
    };
    if (!quantityRequestInFlight) {
      window.clearTimeout(quantityProcessTimer);
      quantityProcessTimer = window.setTimeout(processNextQuantity, quantityProcessDelay);
    }
  }

  function handleRemoveClick(event) {
    var control = event.target.closest('.remove-from-cart, .cart__remove, .cart__popup-remove a');
    if (!control) return;
    var row = control.closest('.cart_item, .ajaxcart__product');
    var input = row && row.querySelector(cartQuantityInputSelector());
    if (!input) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (row.classList.contains('merlons-cart-remove-busy')) return;
    enqueueQuantity(input, 0, { removal: true, removeControl: control, focusControl: control });
  }

  function handleQuantityClick(event) {
    var control = event.target.closest('.cart__mini-qty, .cart__popup-qty, .cart__qty .js-qty__adjust');
    if (!control) return;
    var input = findQuantityInput(control);
    if (!input) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var row = input.closest('.cart_item, .ajaxcart__product');
    if (row && row.classList.contains('merlons-cart-remove-busy')) return;
    var step = parseFloat(input.getAttribute('step')) || 1;
    var isPlus = control.classList.contains('plus') || control.classList.contains('cart__mini-qty--plus') || control.classList.contains('cart__popup-qty--plus');
    var current = parseFloat(input.value) || 0;
    var requested = current + (isPlus ? step : -step);
    var min = parseFloat(input.getAttribute('min'));
    if (!isPlus && requested < (isFinite(min) ? min : 1)) {
      enqueueQuantity(input, 0, { removal: true, removeControl: control, focusControl: control });
      return;
    }
    var next = clampQuantity(input, requested);
    if (next === parseFloat(input.value)) return;
    enqueueQuantity(input, next, { focusControl: control });
  }

  function handleQuantityChange(event) {
    if (!event.target.matches(cartQuantityInputSelector())) return;
    event.stopImmediatePropagation();
    var row = event.target.closest('.cart_item, .ajaxcart__product');
    if (row && row.classList.contains('merlons-cart-remove-busy')) return;
    var requested = parseFloat(event.target.value);
    if (isFinite(requested) && requested <= 0) {
      enqueueQuantity(event.target, 0, { removal: true, removeControl: event.target, focusControl: event.target });
      return;
    }
    var quantity = clampQuantity(event.target, event.target.value);
    enqueueQuantity(event.target, quantity, { focusControl: event.target });
  }

  function suppressLegacyQuantityKeyup(event) {
    if (event.target.matches('.cart__qty-input, .cart__popup-qty--input')) {
      event.stopImmediatePropagation();
    }
  }

  function handleCartKeyboardActivation(event) {
    if (event.key === 'Escape' && !event.defaultPrevented && !event.isComposing) {
      var openDrawer = document.querySelector('#desktop_cart.active');
      var closeControl = openDrawer && openDrawer.querySelector('.close_cart');
      if (closeControl) {
        event.preventDefault();
        closeControl.click();
      }
      return;
    }
    var control = event.target.closest('.header-cart[role="button"]');
    if (!control || control.tagName === 'BUTTON' || (control.tagName === 'A' && control.hasAttribute('href')) || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    control.click();
  }

  function handleHeaderCartClick(event) {
    var trigger = event.target.closest('.header-cart');
    var drawerAtClick = document.getElementById('desktop_cart');
    var closingCart = !trigger && !!event.target.closest('.close_cart, .sidebar-overlay') && !!(drawerAtClick && drawerAtClick.classList.contains('active'));
    if (trigger) lastHeaderCartTrigger = trigger;
    if (!trigger && !closingCart) return;
    window.requestAnimationFrame(function () {
      syncHeaderCartExpandedState();
      var drawer = document.getElementById('desktop_cart');
      if (trigger || !closingCart || (drawer && drawer.classList.contains('active')) || !lastHeaderCartTrigger || !lastHeaderCartTrigger.isConnected) return;
      lastHeaderCartTrigger.focus({ preventScroll: true });
    });
  }

  function releaseCartPopupScrollLock() {
    if (!document.body) return;
    document.body.classList.remove('cart_popup_opened');
  }

  function bindCartPopupScrollLockCleanup() {
    if (!window.jQuery) return;
    window.jQuery(document)
      .off('novClose.merlonsCartScrollLock')
      .on('novClose.merlonsCartScrollLock', releaseCartPopupScrollLock)
      .off('ajaxError.merlonsCartScrollLock')
      .on('ajaxError.merlonsCartScrollLock', function (_event, _request, settings) {
        if (settings && /\/cart\/\?view=upsell(?:&|$)/.test(settings.url || '')) {
          releaseCartPopupScrollLock();
        }
      });
  }

  function start() {
    window.MerlonsCartUI = window.MerlonsCartUI || {};
    window.MerlonsCartUI.applyCartState = function (cart) {
      if (!cart) return;
      lastKnownCart = cart;
      applyFinalCartState(cart);
      syncQuantityFragments(cart);
    };
    repairCartIcons(document);
    scheduleMiniCartDiscountRefresh(false);
    document.addEventListener('click', handleRemoveClick, true);
    document.addEventListener('click', handleQuantityClick, true);
    document.addEventListener('change', handleQuantityChange, true);
    document.addEventListener('keyup', suppressLegacyQuantityKeyup, true);
    document.addEventListener('keydown', handleCartKeyboardActivation, true);
    document.addEventListener('click', handleHeaderCartClick, true);
    bindCartPopupScrollLockCleanup();
    document.addEventListener('merlons:order-request:cart-updated', function (event) {
      if (event.detail && event.detail.cart) window.MerlonsCartUI.applyCartState(event.detail.cart);
    });
    if (!document.body || !window.MutationObserver) return;
    var cartDrawer = document.getElementById('desktop_cart');
    if (cartDrawer) {
      new MutationObserver(syncHeaderCartExpandedState).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    }
    new MutationObserver(function (mutations) {
      var cartChanged = false;
      var cartLabelsChanged = false;
      var headerCountChanged = false;
      mutations.forEach(function (mutation) {
        if (mutation.target.nodeType === 1 && mutation.target.matches('.cart-message')) {
          repairCartIcons(mutation.target);
        }
        if (mutation.type === 'childList') {
          if (mutation.target.nodeType === 1 && mutation.target.closest('.CartCount, #CartCountCavas')) headerCountChanged = true;
          Array.prototype.forEach.call(mutation.addedNodes, function (node) {
            repairCartIcons(node);
            updateLocalizedCartLabels(node);
          });
          if (mutationTouchesMiniCart(mutation)) cartChanged = true;
          if (mutation.target.nodeType === 1 && mutation.target.closest('.cart-popup-heading')) cartLabelsChanged = true;
        }
      });
      if (cartChanged) {
        discountContentVersion += 1;
        scheduleMiniCartDiscountRefresh(false);
      }
      if (cartLabelsChanged) updateLocalizedCartLabels(document.querySelector('#cart-info'));
      if (headerCountChanged) updateHeaderCartAccessibleNames();
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
